import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import FloatingIcons from './FloatingIcons';

interface HeroProps {
  readonly isVisible: boolean;
}

function Hero({ isVisible }: HeroProps) {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (hash: string) => {
    const isOnHomePage = location.pathname === '/';
    
    if (isOnHomePage) {
      // If on home page, just scroll to section
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // If not on home page, navigate to home first, then scroll after navigation
      navigate('/', { state: { scrollTo: hash } });
    }
  };

  return (
    <section className="hero-section">
      <FloatingIcons />

      <div className="hero-container">
        <div className={`hero-content ${isVisible ? 'fade-in' : ''}`}>
          <h1 className="hero-title">
            Director, Delivery & Innovation
          </h1>
          <h2 className="hero-subtitle">
            Salesforce Solution Architect
          </h2>
          <p className="hero-description">
            Expert in Salesforce development, solution architecture, and team leadership.<br/>
            Spent one and half decade delivering scalable solutions and driving innovation in cloud technologies.
          </p>
          <div className="hero-cta">
            <button 
              className="cta-button primary" 
              onClick={() => handleNavClick('#career')}
            >
              View Experience
            </button>
            <button 
              className="cta-button secondary" 
              onClick={() => handleNavClick('#contact')}
            >
              Get in Touch
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;

